import axiosInstance from './AxiosInstance';

const API_URL = 'facilitybuildingroom';

export const getFacilityBuildingRooms = async () => {
    try {
        const response = await axiosInstance.get(`${API_URL}/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching facility building rooms', error);
        throw error;
    }
};

export const getFacilityBuildingRoomsList= async () => {
    try {
        const response = await axiosInstance.get(`${API_URL}/`);
        return response.data.map((f) => ({
            value: f.value,
            label: f.label,
        }));
    } catch (error) {
        console.error('Error fetching facility building rooms', error);
        return [];
    }
};

export const getFacilityBuildingRoomById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/view/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching facility building room with id ${id}`, error);
        throw error;
    }
};

export const createFacilityBuildingRoom = async (room) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/add`, room);
        return response.data;
    } catch (error) {
        console.error('Error creating facility building room', error);
        throw error;
    }
};

export const updateFacilityBuildingRoom = async (id, room) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...room });
        return response.data;
    } catch (error) {
        console.error(`Error updating facility building room with id ${id}`, error);
        throw error;
    }
};

export const deleteFacilityBuildingRoom = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete`, { id: id });
        return response.data;
    } catch (error) {
        console.error(`Error deleting facility building room with id ${id}`, error);
        throw error;
    }
};
